import request from "./request";

export default class Billing {
    static getCoupon = async (code, currency, intake_id) => {
        return await request.get(`${window.base_url}/api_v3/billing/getCoupon`, {
            params: {
                code: code,
                currency: currency ? currency : '',
                intake_id: intake_id ? intake_id : ''
            }
        });
    }

    static getCards = async (room_code) => {
        return await request.get(`${window.base_url}/api_v3/billing/sources`, {
            params: {
                room_code: room_code
            }
        });
    }

    static addCard = async (token, room_code) => {
        return await request.post(`${window.base_url}/api_v3/billing/sources`, {
            token: token,
            room_code: room_code
        });
    }

    static removeCard = async (card, room_code) => {
        return await request.delete(`${window.base_url}/api_v3/billing/sources/${encodeURIComponent(card)}`, {
            params: {
                room_code: room_code
            }
        });
    }

    static updateDefaultCard = async (card_id, room_code) => {
        return await request.put(`${window.base_url}/api_v3/billing/sources/${card_id}?room_code=${room_code}`, {
            is_default: 1
        });
    }

    static processVisitPayment = async (intake, payment) => {
        var data = {...intake.consultation};
        if (intake.id) {
            data.intake_id = intake.id;
        }
        if (payment.promo_code) {
            data.promo_code = payment.promo_code;
        }
        return await request.post(`${window.base_url}/api_v3/billing/invoices/process`, data);
    }
}